<template>
  <div class="home">
    <div class="home-box" v-if="!IsMobile">
      <Carousel autoplay indicator-position="none" :loop="true" :autoplay-speed="4000" dots="none" arrow="never">
        <CarouselItem v-for="item in homeCarousel" :key="item.id"  class="home-carousel">
          <img :src="item.imgPath" />
        </CarouselItem>
      </Carousel>
    </div>
    <div v-if="IsMobile" class="home-box">
      <van-swipe :autoplay="4000" indicator-color="white" :show-indicators="false">
        <van-swipe-item  v-for="item in homeCarousel" :key="item.id" class="home-carousel">
          <img :src="item.imgPath" />
        </van-swipe-item>
      </van-swipe>
      <img v-if="topImg.length > 0" :src="topImg[0].imgPath" class="top-img">
      <a v-for="(item) in bottomImg" :key="item.id" :href="item && item.jumpPath" class="bottom-img"><img :src="item.imgPath"></a>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { IsMobile } from "@/utils";

export default Vue.extend({
  name: "",
  data() {
    return {
      homeCarousel: [],
      bottomImg: [],
      topImg: [{ imgPath: "" }],
      homeBottom: null,
      IsMobile,
      showIndex: 1,
    };
  },
  created() {
    this.getList();
    if (IsMobile) {
      this.getTopImgList();
      this.getBottomImgList();
    }
  },
  methods: {
    getList() {
      this.$https
        .get("/api/publicresources/getPublicResources", {
          params: {
            type: "carousel",
            isMobile: IsMobile ? 2 : 1,
          },
        })
        .then((res) => {
          this.homeCarousel = res.data;
          const len = this.homeCarousel.length;
          const timer = setInterval(() => {
            if (this.showIndex == len) {
              this.showIndex = 0;
            }
            this.showIndex++;
          }, 3000);
          this.$once("hook:beforeDestroy", () => {
            clearInterval(timer);
          });
        });
    },
    getBottomImgList() {
      this.$https
        .get("/api/publicresources/getPublicResources", {
          params: {
            type: "homebottom",
            isMobile: 2,
          },
        })
        .then((res) => {
          this.bottomImg = res.data;
        });
    },
    getTopImgList() {
      this.$https
        .get("/api/publicresources/getPublicResources", {
          params: {
            type: "hometop",
            isMobile: 2,
          },
        })
        .then((res) => {
          this.topImg = res.data;
        });
    },
  },
});
</script>
<style>
  .ivu-carousel-track{
    transition: transform .8s ease-in-out !important;
  }
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
  }
</style>